import CustomDialog from 'widgets/component/CustomDialog';
import ContentRechargeHistory from './ContentRechargeHistoryComponent.jsx';

const CustomDialogs = ({
  // Recharge History Dialog props
  isDialogOpenRechargeHistory,
  setisDialogOpenRechargeHistory,
  rechargeHistoryAction,
  ticketId,
  rechargeHistory,
  rechargeHistoryClean,

  // Change User Dialog props
  isDialogOpen,
  setIsDialogOpen,
  dialogMessage,
}) => {
  return (
    <>
      <CustomDialog
        title='Historial de recargas'
        content={
          <ContentRechargeHistory
            rechargeHistoryAction={rechargeHistoryAction}
            ticketId={ticketId}
            rechargeHistory={rechargeHistory}
            rechargeHistoryClean={rechargeHistoryClean}
          />
        }
        onClose={() => {
          rechargeHistoryClean();
          setisDialogOpenRechargeHistory(false);
        }}
        open={isDialogOpenRechargeHistory}
        fullWidth
        maxWidth=''
        showCloseButton={false}
        extraButtons={[
          {
            label: 'Cerrar',
            variant: 'contained',
            onClick: () => {
              localStorage.removeItem('rechargeHistoryDatesPayload');
              rechargeHistoryClean();
              setisDialogOpenRechargeHistory(false);
            },
            buttonColor: '#724ECB',
            textColor: 'white',
          },
        ]}
      />
      <CustomDialog
        title='Cambio de Usuario'
        content={dialogMessage}
        onClose={() => setIsDialogOpen(false)}
        open={isDialogOpen}
        fullWidth
        maxWidth='xs'
        showCloseButton={false}
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: () => setIsDialogOpen(false),
            buttonColor: '#724ECB',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

export default CustomDialogs;
